import { RelatorioReceitasItem } from "../typings";

import http from "infra/http";
import { RelatorioReceitasQueryParams } from "../typings/index";
import { useInfiniteQuery } from "react-query";
import { PaginateResult } from "core/resources/types/shared";

function useRelatorioReceitasInfiniteScroll(
  params: RelatorioReceitasQueryParams
) {
  return useInfiniteQuery(
    [`/v1/relatorios/financeiro/receitas/paginado`, params],
    async ({ pageParam }) => {
      const { data } = await http.get<PaginateResult<RelatorioReceitasItem>>(
        "/v1/relatorios/financeiro/receitas/paginado",
        {
          params: { ...params, page: pageParam ?? 1 },
        }
      );

      return data;
    },
    {
      getNextPageParam: (lastPage) =>
        lastPage.meta.currentPage === lastPage.meta.totalPages
          ? undefined
          : lastPage.meta.currentPage + 1,
    }
  );
}

export default useRelatorioReceitasInfiniteScroll;
